// extracted by mini-css-extract-plugin
module.exports = {"corner__float-bottom-right":"style_corner__float-bottom-right__2Qf-0"};